import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { BankContainerModel } from "../../../../../../models/aggregates/erp/bank/bank-container.model";

@Injectable({ providedIn: "root" })
export class BankService extends BaseApiTemplateService<BankContainerModel> {
  readonly url =
    Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "bank";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "bank";
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "bank";
    this.httpClient = http;
  }
}
